import {
  UserFileTypes,
  viewPatientAssociatedFile,
  viewReferralAssociatedFile,
  viewScreeningAssociatedFile,
} from "@/utils/fileUtil";

import type { FileListType, FileListTypeConfig } from "../types";

// Single source of truth for the per-`type` static behavior that used to be scattered
// across if/else chains in componentDidMount and render.
export const FILE_LIST_CONFIG: Record<FileListType, FileListTypeConfig> = {
  a5_screenings: {
    backLinkText: "Back to A5 Screening",
    fileType: UserFileTypes.ASSOCIATED_FILE_SCREENING,
    viewFile: viewScreeningAssociatedFile,
  },
  patient: {
    backLinkText: "Back to Patient Profile",
    fileType: UserFileTypes.ASSOCIATED_FILE_PATIENT,
    viewFile: viewPatientAssociatedFile,
  },
  referral: {
    backLinkText: "Back to Referral",
    fileType: UserFileTypes.ASSOCIATED_FILE_REFERRAL,
    viewFile: viewReferralAssociatedFile,
  },
};
